// src/data/comedians/bo-burnham.js

const base = {
  id: 'bo-burnham',
  slug: 'bo-burnham',
  name: 'Bo Burnham',
  birthYear: 1990,
  image: require('@/assets/images/img_Bo_Burnham.jpg'),
  famousWorks: [
    'Inside (2021)',
    'Make Happy (2016)',
    'what. (2013)',
    'Eighth Grade (2018)',
    'Words, Words, Words',
    'Zach Stone Is Gonna Be Famous',
    'Promising Young Woman (actor)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Musical comedy innovator and filmmaker',
    bio: `Bo Burnham is an American comedian, musician, actor, and filmmaker who rose to fame through YouTube before becoming one of comedy's most innovative and introspective voices. His unique blend of music, comedy, and social commentary, combined with his willingness to explore mental health and existential themes, has redefined what comedy specials can be.\n\nBorn in Hamilton, Massachusetts, Burnham began posting comedy songs on YouTube at age 16 and quickly gained a massive following. He became the youngest person to record a Comedy Central special at age 18. His comedy evolved from clever wordplay and musical parodies to increasingly sophisticated examinations of performance, technology, and modern life.\n\nBurnham's Netflix special "Inside," created entirely by himself during the COVID-19 pandemic, became a cultural phenomenon and earned critical acclaim for its honest exploration of isolation, mental health, and internet culture. He has also found success as a filmmaker, directing the acclaimed film "Eighth Grade."`,
    style: 'Musical comedy, meta-humor, introspective, multimedia performance',
    achievements: [
      'Emmy Awards',
      'Grammy nomination',
      'Peabody Award',
      'Writers Guild Award',
      'Directors Guild nomination',
      'Cultural impact of Inside',
      'Innovative YouTube pioneer',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Innovateur de la comédie musicale et cinéaste',
    bio: `Bo Burnham est un comédien, musicien, acteur et cinéaste américain qui a acquis la célébrité grâce à YouTube avant de devenir l'une des voix les plus innovantes et introspectives de la comédie. Son mélange unique de musique, de comédie et de commentaire social, combiné à sa volonté d'explorer la santé mentale et les thèmes existentiels, a redéfini ce que peuvent être les specials de comédie.\n\nNé à Hamilton, Massachusetts, Burnham a commencé à poster des chansons comiques sur YouTube à 16 ans. Sa comédie a évolué des jeux de mots habiles et des parodies musicales vers des examens de plus en plus sophistiqués de la performance, de la technologie et de la vie moderne.\n\nSon spécial Netflix "Inside", créé entièrement par lui-même pendant la pandémie de COVID-19, est devenu un phénomène culturel pour son exploration honnête de l'isolement et de la santé mentale.`,
    style: 'Comédie musicale, méta-humour, introspectif, performance multimédia',
    achievements: [
      'Emmy Awards',
      'Nomination aux Grammy',
      'Peabody Award',
      'Writers Guild Award',
      'Nomination aux Directors Guild',
      'Impact culturel de Inside',
      'Pionnier innovant de YouTube',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Innovador de la comedia musical y cineasta',
    bio: `Bo Burnham es un comediante, músico, actor y cineasta estadounidense que se hizo famoso a través de YouTube antes de convertirse en una de las voces más innovadoras e introspectivas de la comedia. Su mezcla única de música, comedia y comentario social, combinada con su disposición a explorar la salud mental y los temas existenciales, ha redefinido lo que pueden ser los especiales de comedia.\n\nNacido en Hamilton, Massachusetts, Burnham comenzó a publicar canciones cómicas en YouTube a los 16 años. Su comedia evolucionó desde ingeniosos juegos de palabras y parodias musicales hacia exámenes cada vez más sofisticados de la actuación, la tecnología y la vida moderna.\n\nSu especial de Netflix "Inside", creado completamente por él mismo durante la pandemia de COVID-19, se convirtió en un fenómeno cultural por su honesta exploración del aislamiento y la salud mental.`,
    style: 'Comedia musical, meta-humor, introspectivo, actuación multimedia',
    achievements: [
      'Emmy Awards',
      'Nominación al Grammy',
      'Peabody Award',
      'Writers Guild Award',
      'Nominación a Directors Guild',
      'Impacto cultural de Inside',
      'Pionero innovador de YouTube',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'مبتكر الكوميديا الموسيقية وصانع الأفلام',
    bio: `بو بورنهام كوميدي وموسيقي وممثل ومخرج أمريكي اشتُهر عبر YouTube ليصبح أحد أكثر أصوات الكوميديا ابتكارًا وتأمّلًا. مزيجه الفريد من الموسيقى والكوميديا والتعليق الاجتماعي مع استعداده لاستكشاف الصحة النفسية والموضوعات الوجودية أعاد تعريف ما يمكن أن يكون عليه العرض الكوميدي الخاص.\n\nوُلد في هاملتون بماساتشوستس وبدأ نشر أغنيات كوميدية على YouTube في سن السادسة عشرة. تطورت كوميديا من لعب الكلمات الذكي والمحاكاة الساخرة الموسيقية نحو فحص أكثر تطورًا للأداء والتكنولوجيا والحياة الحديثة.\n\nعرضه الخاص على Netflix "Inside" الذي أنجزه وحده تمامًا خلال جائحة كوفيد-19 أصبح ظاهرة ثقافية لاستكشافه الصادق للعزلة والصحة النفسية وثقافة الإنترنت.`,
    style: 'كوميديا موسيقية، ميتا-فكاهة، تأملي، أداء وسائطي متعدد',
    achievements: [
      'جوائز Emmy',
      'ترشيح Grammy',
      'Peabody Award',
      'Writers Guild Award',
      'ترشيح Directors Guild',
      'تأثير ثقافي واسع لـ Inside',
      'رائد مبتكر على YouTube',
    ],
  },
];
